import React, { Component } from "react";
import styles from "./Email.module.css";
import Language from "../utils/Language";

// Stored as char codes with a +7 offset so the literal address never
// appears in the JS bundle — crawlers grepping for "@" or running an
// email regex against the source won't match.
const ENC = [
  124, 108, 115, 122, 123, 124, 107, 112, 118, 122, 71, 119, 104, 124, 115, 52,
  125, 118, 117, 52, 104, 115, 115, 126, 118, 108, 121, 107, 108, 117, 53, 107,
  108
];

function decode() {
  let out = "";
  for (let i = 0; i < ENC.length; i++) {
    out += String.fromCharCode(ENC[i] - 7);
  }
  return out;
}

class Email extends Component {
  constructor(props) {
    super(props);
    this.state = { value: null };
    this.reveal = this.reveal.bind(this);
  }

  reveal() {
    if (this.state.value) return;
    this.setState({ value: decode() });
  }

  render() {
    const { value } = this.state;

    if (!value) {
      return (
        <button
          type="button"
          className={styles.Reveal}
          onClick={this.reveal}
          aria-label={Language.GetString("email_reveal")}
        >
          {Language.GetString("email_reveal")}
        </button>
      );
    }

    return (
      <a className={styles.Link} href={"mailto:" + value}>
        {value}
      </a>
    );
  }
}

export default Email;
